import React from "react";

import { FaFacebookF } from "@react-icons/all-files/fa/FaFacebookF";
import { FaGoogle } from "@react-icons/all-files/fa/FaGoogle";
import { FaInstagram } from "@react-icons/all-files/fa/FaInstagram";
import { FaTwitter } from "@react-icons/all-files/fa/FaTwitter";
import { useTranslation } from "react-i18next";
import { Link, Outlet, useNavigate } from "react-router-dom-v5-compat";

import { ErrorBox, PageContent, TitleBar } from "../Atoms";
import { createCart, deleteCart, deleteSession } from "../Cart/requests";
import {
  useCurrentCustomerTab,
  useCustomerTabQuery,
} from "../CustomerTab/queries";
import { LoadingPage, isLoading } from "../Loading";
import { LogoImage } from "../MainPage";
import { useSession, useSessionDispatch } from "../Session/SessionContext";
import { useVenue } from "../VenueContext";
import { useTimeoutSearchParam } from "./useTimeoutSearchParam";

const SocialLink = ({
  href,
  icon,
}: {
  href?: string | null;
  icon: React.ReactNode;
}) => {
  if (!href) {
    return null;
  }
  return (
    <a
      href={href}
      className="p-8 shadow-venue-brand-style bg-venue-tertiary rounded-venue-brand hover:bg-venue-primary hover:text-white"
    >
      {icon}
    </a>
  );
};

const CheckoutLayout = ({ title }: { title: string }) => {
  const { t } = useTranslation();

  const venue = useVenue();
  const hasJustCancelledPayment = useTimeoutSearchParam("payment");

  return (
    <div className="pb-64 md:py-24 space-y-24">
      <div className="md:flex">
        <Link to="/" className="hidden flex-1 md:flex items-center space-x-16">
          <div className="max-w-[64px] w-full">
            <LogoImage venue={venue} />
          </div>
          <div className="text-venue-primary text-lg font-bold">
            {venue.name}
          </div>
        </Link>
        <div className="md:flex-1">
          <TitleBar>
            <div className="md:text-4xl md:font-bold">{title}</div>
          </TitleBar>
        </div>
        <div className="hidden md:flex flex-1 w-full justify-end items-center space-x-12">
          <SocialLink href={venue.twitterUserName} icon={<FaTwitter />} />
          <SocialLink href={venue.facebookPageUrl} icon={<FaFacebookF />} />
          <SocialLink href={venue.instagramUserName} icon={<FaInstagram />} />
        </div>
      </div>

      <div className="space-y-32 ">
        {hasJustCancelledPayment && (
          <div className="mx-auto max-w-screen-sm ">
            <ErrorBox>{t("cart.paymentCancelled")}</ErrorBox>
          </div>
        )}
        <Outlet />

        <div className="py-48 text-center">
          <Link to="/clear" className="text-venue-highlight">
            {t("cart.closeCart")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CheckoutLayout;
